<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <!-- 订单详情 -->
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>
  </cTable>
</template>

<script>
import { getAllClient } from "@/api/user/client";
// import { getOrderDetails } from "@/api/order/list";
import { getList, setBindPackage } from "@/api/order/firstOrder";
// import { getUser } from "@/api/user/internal";
// import { getCountry } from "@/api/system/country";

import Tracker from "@/base/order_tracker";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import order from "_c/order-details";
import cTable from "@/base/common/index";
export default {
  props: {
    type: {
      type: Number,
      default: 3,
    },
  },
  name: "goods",
  components: {
    cTable,
    Tracker,
    order,
  },
  async mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      // if (item.key === "serviceId")
      //   item.options = (
      //     await getUser({ standard: "DblCustomerService" })
      //   ).data.payload.rows;
      // if (item.key === "salesmanId")
      //   item.options = (
      //     await getUser({ standard: "Salesman" })
      //   ).data.payload.rows;
      // if (item.key === "to_country")
      //   item.options = (await getCountry()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: (p) => {
          return getList(p);
        },
        getAllClient,
        setBindPackage,
        // updateSheet,
        // getOrderDetails,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600,
            },
          },
          footer: { show: () => false },
        },
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%",
            },
          },
          footer: {
            show: false,
          },
        },
        relation: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("setBindPackage", row, true)
                .then((res) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          config: {
            rules: {
              package_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                },
              ],
              packing_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            title: this.$t("pushProxy"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [
            { package_number: 24 },
            {
              packing_number: 24,
            },
          ],
          fields: [
            {
              key: "package_number",
              name: () => this.$t("bagNum"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagNum");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
            {
              key: "packing_number",
              name: () => this.$t("packing_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("packing_number");
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "clientId",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          // {
          //   key: "serviceId",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("serviceAccount");
          //   },
          //   options: [],
          //   config: { label: "account", value: "id" },
          // },
          // {
          //   key: "salesmanId",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("salesman");
          //   },
          //   options: [],
          //   config: { label: "account", value: "id" },
          // },
          // {
          //   key: "to_country",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("target_country");
          //   },
          //   options: [],
          //   config: { label: "code", value: "code" },
          // },
          // {
          //   key: "service_code",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //   },
          //   placeholder() {
          //     return this.$t("select") + this.$t("company");
          //   },
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       field.options = await this.$sel.getData("NOON_SERVICE");
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
              // autosize: { minRows: 2, maxRows: 2 }
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("relation") + this.$t("packing"),
              type: "relation",
              fnName: "relationFun",
              id: 1228,
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            relationFun() {
              this.getModal("relation").open(null, function () {
                this.setTitle(this.$t("relation") + this.$t("packing"));
              });
            },
            export() {
              this.exportExc();
            },
            importFun({ file, searchForm }) {
              this.getModal("upload").open(null, function () {
                this.setTitle(this.$t("updateFile"));
                this.disabledConfirm = true;
              });
              // let formData = new FormData();
              // formData.append("file", file);
              // formData.append("client_id", searchForm.client_id);
              // this.$page
              //   .handleRequestMethods("updateSheet", formData, true)
              //   .then(res => {
              //     this.$page.getList();
              //   });
              // return false;
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          fixed: "left",
          copy: true,
          width: 150,
          // component: "Button",
          // bind: {
          //   type: "primary",
          //   size: "small",
          // },
          // align: "center",
          // showOverflow: false,

          // methods: {
          //   click({ row }) {
          //     this.$page
          //       .handleRequestMethods("getOrderDetails", row.airway_number)
          //       .then((res) => {
          //         this.$page.getModal("orderDetail").open(
          //           {
          //             dataDetails: res.payload,
          //           },
          //           function () {
          //             this.setTitle(row.airway_number);
          //           }
          //         );
          //       });
          //   },
          // },
        },
        {
          name: () => this.$t("bagNum"),
          key: "package_number",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          align: "center",
          minWidth: 125,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          minWidth: 125,
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 120,
        },
      ],
    };
  },
};
</script>
